module.exports = __webpack_public_path__ + "static/bentonsanscond-regular-webfont-c8c909e422fadf4690e7b47e2f5e2d94.woff";